<template>
    <div>
        <b-modal @ok="exportReport" size="m" :centered="true" :id="dialogId" title="Export data" title-class="ml-auto">
            <div class="d-inline-flex">
                <div class="textwrapper">
                    <label class="labelclass" for="switch_1">Header: </label>
                </div>
                <div class="switchwrapper">
                    <b-form-checkbox id="switch_1" v-model="includeHeader" switch class="ml-2 d-inline-block"></b-form-checkbox>
                    <label class="labelclass" for="switch_1">{{ includeHeader ? "Yes" : "No" }}</label>
                </div>
            </div>
            <div class="d-inline-flex">
                <div class="textwrapper">
                    <label class="labelclass" for="switch_2">Summary: </label>
                </div>
                <div class="switchwrapper">
                    <b-form-checkbox id="switch_2" v-model="summarize" switch class="ml-2 d-inline-block"></b-form-checkbox>
                    <label class="labelclass" for="switch_2">{{ summarize ? "Yes" : "No" }}</label>
                </div>
            </div>
            <div class="d-inline-flex">
                <div class="textwrapper">
                    <label class="labelclass" for="switch_4">Both Abs/Rel: </label>
                </div>
                <div class="switchwrapper">
                    <b-form-checkbox id="switch_4" v-model="bothAbsRel" switch class="ml-2 d-inline-block"></b-form-checkbox>
                    <label class="labelclass" for="switch_4">{{ bothAbsRel ? "Yes" : "No" }}</label>
                </div>
            </div>
            <h5 class="mt-2">Detail rows</h5>
            <div v-for="(tableViewMode, index) in tableViewModesCheckboxes" :key="index + 5" class="d-inline-flex">
                <div class="textwrapper">
                    <label class="labelclass" :for="`switch_${index + 5}`">{{ tableViewMode.label }}: </label>
                </div>
                <div class="switchwrapper">
                    <b-form-checkbox :id="`switch_${index + 5}`" v-model="tableViewMode.checked" switch class="ml-2 d-inline-block"></b-form-checkbox>
                    <label class="labelclass" :for="`switch_${index + 5}`">{{ tableViewMode.checked ? "Yes" : "No" }}</label>
                </div>
            </div>
            <template v-slot:modal-footer="{ ok }">
                <b-button size="sm" variant="outline-secondary" @click="$bvModal.hide(dialogId)">
                    Cancel
                </b-button>
                <b-button size="sm" variant="primary" @click="ok()">
                    Ok
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { dateToyymmddFormat } from "../../../../api/utils.js"
import { downloadBlob, arrayToCsv, replace000sOrPercent } from "@/helpers/index.js"

export default {
    name: "ExportDialogReport",
    props: {
        dialogId: String,
        tableViewModes: Array,
    },
    computed: {
        adsUniverseSize() {
            let chosenTargetGroup = this.$store.getters.getAdsCampaignReportCurrentTargetGroup
            let universeSize = this.$store.getters.getAdsUniverseSize
                .map(element => {
                    if (element.split(";")[0] === chosenTargetGroup) return element.split(";")[1].replace(/\s/g, "")
                })
                .find(x => x)
            return universeSize
        },
        // hiding the panel size until we have the desired calculation from the backend
        // adsPanelSize() {
        //     let chosenTargetGroup = this.$store.getters.getAdsCampaignReportCurrentTargetGroup
        //     let panelSize = this.$store.getters.getAdsPanelSize
        //         .map(element => {
        //             if (element.split(";")[0] === chosenTargetGroup) return element.split(";")[1].replace(/\s/g, "")
        //         })
        //         .find(x => x)
        //     return panelSize
        // },
        reachTotalMeasureKey() {
            let chosenTargetGroup = this.$store.getters.getAdsCampaignReportCurrentTargetGroup
            let measures = this.$store.getters.getAdsCampaignReportQuery.measures
            let trpTotalKey = measures.reduce((pre, m, index) => {
                let ageText = m.selectedMeasureText.subHeader.replace(/\s.*/, "")
                if (!pre && m.source === "Total" && m.measure === "reach" && ageText === chosenTargetGroup) {
                    return `measure_${index + 1}`
                }
                return pre
            }, null)
            return trpTotalKey
        },
        trpTotalMeasureKey() {
            let chosenTargetGroup = this.$store.getters.getAdsCampaignReportCurrentTargetGroup
            let measures = this.$store.getters.getAdsCampaignReportQuery.measures
            let trpTotalKey = measures.reduce((pre, m, index) => {
                let ageText = m.selectedMeasureText.subHeader.replace(/\s.*/, "")
                if (!pre && m.source === "Total" && m.measure === "trp" && ageText === chosenTargetGroup) {
                    return `measure_${index + 1}`
                }
                return pre
            }, null)
            return trpTotalKey
        },
        totalTrpValue() {
            let trpTotalKey = this.trpTotalMeasureKey
            let summaryRow = this.$store.getters.getAdsCampaignReportResults.data[this.$store.getters.getAdsCampaignReportMeasureSumMode.key]?.totalRow
            return summaryRow[trpTotalKey]
        },
        totalTrpRelValue() {
            let trpRelTotalKey = `${this.trpTotalMeasureKey}_rel`
            let summaryRow = this.$store.getters.getAdsCampaignReportResults.data[this.$store.getters.getAdsCampaignReportMeasureSumMode.key]?.totalRow
            return summaryRow[trpRelTotalKey]
        },
        tableMeasures() {
            return this.$store.getters.getAdsCampaignReportResults.data.measureColumns.filter(m => m.subHeader.includes(this.$store.getters.getAdsCampaignReportCurrentTargetGroup))
        },
        currentTargetGroup() {
            return this.$store.getters.getAdsCampaignReportCurrentTargetGroup
        },
        chosenKeys() {
            return this.$store.getters.getAdsCampaignReportCurrentTargetGroup
        },
        currentRoFData() {
            const rofData = this.$store.getters.getAdsCampaignReportResults.data.RoF.rofMeasures.find(r => r.targetGroup === this.currentTargetGroup)
            return rofData ? rofData.measures : { relativeReach: "n/a", absoluteReach: "n/a" }
        },
        absoluteReach() {
            return this.currentRoFData.absoluteReach
        },
        relativeReach() {
            return this.currentRoFData.relativeReach
        }
    },
    data() {
        return {
            includeHeader: true,
            summarize: true,
            bothAbsRel: true,
            tableViewModesCheckboxes: this.getTableViewModesCheckboxes(),
        }
    },
    methods: {
        getViewModeColumns(viewMode) {
            if (this.$store.getters.getAdsCampaignReportResults.data[viewMode].status === "LOADED") {
                let measureTypeSelected = this.$store.getters.getAdsCampaignReportMeasureTypeSelected
                let tableMeasures = [...this.tableMeasures]
                if (this.bothAbsRel) {
                    if (measureTypeSelected === "absolute_reach")
                        tableMeasures = this.tableMeasures.concat(
                            this.tableMeasures.map(obj => {
                                let relObj = { ...obj }
                                relObj.key = obj.key + "_rel"
                                relObj.header = replace000sOrPercent(relObj.header)
                                relObj.label = `${relObj.header} ${relObj.subHeader}`
                                return relObj
                            })
                        )
                    else
                        tableMeasures = [
                            ...this.tableMeasures.map(obj => {
                                let absObj = { ...obj }
                                absObj.key = obj.key.slice(0, -4)
                                absObj.header = replace000sOrPercent(absObj.header)
                                absObj.label = `${absObj.header} ${absObj.subHeader}`
                                return absObj
                            }),
                            ...this.tableMeasures,
                        ]
                }
                return this.$store.getters.getAdsCampaignReportResults.data[viewMode].viewTypeColumns.concat(tableMeasures)
            } else {
                return []
            }
        },
        getTableViewModesCheckboxes() {
            return [
                ...this.tableViewModes.map(obj => {
                    return { ...obj, checked: true }
                }),
            ]
        },
        exportReport() {
            let excellData = this.convertCampaignReportDataToArray()
            this.createAndDownloadExcelFile(excellData)
        },
        convertCampaignReportDataToArray() {
            let tableViewModesExcelData = []
            if (this.includeHeader) {
                let headerData = this.$store.getters.getAdsCampaignReportQuery?.headerData
                tableViewModesExcelData = tableViewModesExcelData.concat([
                    ["Period:", headerData?.dateRange],
                    ["Channels:", headerData?.providers.join(", ")],
                    ["Film codes:", headerData?.filmCodes.join(", ")],
                    ["Target groups:", this.currentTargetGroup],
                    ["Advertisers:", headerData?.advertisers.join(", ")],
                    ["Products:", headerData?.products.join(", ")],
                    ["Agencies:", headerData?.buyingAgencies.join(", ")],
                ])
            }
            if (this.summarize) {
                tableViewModesExcelData = tableViewModesExcelData.concat([
                    [""],
                    ["Universe size:", this.adsUniverseSize],
                    // hiding the panel size until we have the desired calculation from the backend
                    // ["Panel size:", this.adsPanelSize],
                    ["Net Reach 1+:", this.absoluteReach, this.relativeReach],
                    ["TRP:", this.totalTrpValue, this.totalTrpRelValue],
                ])
            }
            let chosenViewModes = this.tableViewModesCheckboxes.filter(vm => vm.checked)
            for (const chosenViewMode of chosenViewModes) {
                let columns = this.getViewModeColumns(chosenViewMode.key)
                let detailRows = [[""], [""]]
                let detailRowColumns = []
                for (const column of columns) {
                    detailRowColumns.push(column.label)
                }
                detailRows.push([...detailRowColumns])
                let totalRow = this.$store.getters.getAdsCampaignReportResults.data[chosenViewMode.key]?.totalRow ?? []
                totalRow[columns[0].key] = "CALCULATION"
                let tableRows = this.$store.getters.getAdsCampaignReportResults.data[chosenViewMode.key]?.levelOneAdsWithLevelTwoAds ?? []
                let allTableRows = [totalRow, ...tableRows]
                for (const row of allTableRows) {
                    let detailRow = []
                    for (const column of columns) {
                        detailRow.push(row[column.key])
                    }
                    detailRows.push(detailRow)
                }
                tableViewModesExcelData = tableViewModesExcelData.concat([...detailRows])
            }
            tableViewModesExcelData.push([""])
            return tableViewModesExcelData
        },
        createAndDownloadExcelFile(csvArray) {
            let csv = arrayToCsv(csvArray)
            downloadBlob(csv, `Campaign_Report_MMS_CROSS-PLATFORM ${dateToyymmddFormat(new Date())}.csv`, "text/csv;charset=utf-8;")
        },
    },
}
</script>

<style scoped>
>>> .modal-body {
    width: 15rem;
    margin: auto;
    padding-left: 0;
}
.flex-grid {
    display: flex;
}
.textwrapper {
    width: 10rem;
}
.switchwrapper {
    width: 5rem;
}
.form {
    display: inline-grid;
}
.labelclass {
    font-size: 1rem;
    margin-bottom: 0.2rem;
    margin-right: 0.2rem;
}
</style>
